import React from 'react';
import PropTypes from 'prop-types';

const MembershipLayout = ({ children }) => (
  <div className="c-notifications c-membership-layout">
    {children}
  </div>
);

MembershipLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MembershipLayout;



// WEBPACK FOOTER //
// ./src/app/notifications/layouts/MembershipLayout.jsx